import { ChangeDetectorRef, Component } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SlidingBackgroundComponent } from '../components/sliding-background/sliding-background.component';
import { NivoSliderComponent } from "../components/nivo-slider/nivo-slider.component";
import { NewsListComponent } from "../components/news-list/news-list.component";
import { Farm, News, Organisation, Product, Review } from '../../models/types';
import { OrganisationServiceService } from '../services/organisation-service.service';
import { imageLocation } from '../../environments/environment.development';
import { EventListComponent } from "../components/event-list/event-list.component";
import { EventService } from '../services/event.service';
import { Event } from '../../models/types';
import { GalleryImage, GalleryItemEvent, GalleryModule } from '@daelmaak/ngx-gallery';
import { LoginService } from '../services/login.service';
import { RouterLink } from '@angular/router';
import { OrganisationSlugReverseMap, RouteName } from '../../models/enums';
import { MarketPageService } from '../services/market-page.service';
import { ProductListComponent } from '../components/product-list/product-list.component';
import { NgOptimizedImage } from '@angular/common';
@Component({
  selector: 'app-home-page',
  standalone: true,
  imports: [
    CommonModule,
    SlidingBackgroundComponent, 
    NivoSliderComponent, 
    NewsListComponent, 
    EventListComponent, 
    GalleryModule, 
    RouterLink,
    RouterOutlet,
    RouterModule,
    ProductListComponent,
    NgOptimizedImage],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss'
})
export class HomePageComponent {

  news: News[] = [];
  allEvents: Event[] = [];
  selectedImageIndex = 0;
  imageSelected = false;
  marketRoute = "/" + RouteName.market;
  menuOpen = false;
  currentPage: number = 1;
  pageSize: number = 4;
  totalItems: number = 0;
  slugMap = OrganisationSlugReverseMap;
  isLoading = false;
  error = '';
  organisations: Organisation[] = [];
  allProducts: Product[] = [];
  allProductsShow: Product[] = [];
  prodCount = 0;
  vegetableImageUrl = '../../../assets/images/generic/vegetable.png';
  meatImageUrl = '../../../assets/images/generic/meat.png';
  dairyImageUrl = '../../../assets/images/generic/dairy.png';
  otherImageUrl = '../../../assets/images/generic/other.png';
  allFarms: Farm[] = [];
  farmCount = 0;
    images: GalleryImage[] = [
      {
        src: '../../../assets/images/organisations/sports/1.jpg',
        thumbSrc: '../../../assets/images/organisations/sports/1.jpg',
        alt: '',
        description: '',
        data: undefined
      },
      {
        src: '../../../assets/images/organisations/sports/mlajsa-tekaska-sekcija.jpg',
        thumbSrc: '../../../assets/images/organisations/sports/mlajsa-tekaska-sekcija.jpg',
        alt: '',
        description: '',
        data: undefined
      },
      {
        src: '../../../assets/images/organisations/sports/vodstvo.jpg',
        thumbSrc: '../../../assets/images/organisations/sports/vodstvo.jpg',
        alt: '',
        description: '',
        data: undefined
      },
      {
        src: '../../../assets/images/organisations/sports/mucek-se-giba.jpg',
        thumbSrc: '../../../assets/images/organisations/sports/mucek-se-giba.jpg',
        alt: '',
        description: '',
        data: undefined
      },
      {
        src: '../../../assets/images/organisations/sports/8.jpg',
        thumbSrc: '../../../assets/images/organisations/sports/8.jpg',
        alt: '',
        description: '',
        data: undefined
      }
    ];

  constructor(
    private router: Router,
    private organisationService: OrganisationServiceService, 
    private eventService: EventService, 
    private loginService: LoginService,
    private cdr: ChangeDetectorRef,
    private marketPageService: MarketPageService) {}

  ngOnInit() {
    this.loadOrganisations();
    this.fetchAllFarms();
    this.fetchAllProducts();
  }

  getNews() {
    this.isLoading = true;
  
    this.organisationService.getPaginatedNews(this.currentPage, this.pageSize).subscribe({
      next: (response) => {
        if (response && Array.isArray(response.news)) {
          const newNews = this.assignNewsImages(response.news);
  
          // Enrich each news item with the slug
          const enrichedNews = newNews.map(newsItem => {
            const org = this.organisations.find(o => o.organisationID === newsItem.organisationID);
            return {
              ...newsItem,
              organisationSlug: org?.slug ?? 'unknown'
            };
          });
  
          this.news = [...this.news, ...enrichedNews]; // Trigger change detection
          this.totalItems = response.total;
        } else {
          this.news = [];
        }
  
        this.isLoading = false;
      },
      error: (err) => {
        this.error = 'Failed to load news.';
        this.isLoading = false;
      }
    });
  }
  

  normalizeName(name: string): string {
    return name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
   

  loadMoreNews() {
    this.currentPage++;
    this.getNews(); // will use the updated page
  }

  private assignNewsImages(news: News[]): News[] {
    return news.map(newsItem => {
      let defaultImageUrl = '../../../assets/images/generic/news.png';
      newsItem.imageRef = newsItem.imageRef ?
      `${imageLocation}/static/content/news/${newsItem.newsID}/${newsItem.imageRef}` :
      defaultImageUrl;
      return newsItem;
    })
  }

  loadEvents() {
    this.eventService.getAllEvents().subscribe((response) => {
      this.allEvents = response.events!;
      this.allEvents = this.allEvents.filter(event => event.farmID === -1);
      const enrichedEvents = this.allEvents.map(eventItem => {
        const org = this.organisations.find(o => o.organisationID === eventItem.organisationID);
        return {
          ...eventItem,
          organisationSlug: org?.slug ?? 'unknown'
        };
      });
      this.allEvents = enrichedEvents; 
      console.log('All Events:', this.allEvents);
    });
  }

  onThumbClick(event: GalleryItemEvent) {
    this.selectedImageIndex = event.index;
    this.imageSelected = true;
    console.log(`Selected image index: ${this.selectedImageIndex}`);
  }

  loadOrganisations() {
    this.loginService.getAllOrganisations().subscribe({
      next: (response) => {
        if (response.body && Array.isArray(response.body.organisations)) {
          this.organisations = response.body.organisations
            .filter((org: Organisation) => org.organisationID !== -1) // Exclude ARSO 
            .map((org: Organisation) => {
              const normalizedName = this.normalizeName(org.name);
              const slug = OrganisationSlugReverseMap[normalizedName];
              return {
                ...org,
                slug: slug || '' // Avoid undefined
              };
            });
  
          this.cdr.detectChanges(); // Trigger change detection if needed
            const index = this.organisations.findIndex(org => org.organisationID === 4);
            if (index > -1) {
            const [element] = this.organisations.splice(index, 1);
            this.organisations.splice(1, 0, element);
            }
          // 🔹 Now that organisations are loaded with slugs, fetch the news
          this.getNews();
          this.loadEvents();
        } else {
          console.error('Unexpected response structure:', response.body);
        }
      },
      error: (err) => {
        console.error('Error fetching organisations:', err);
      }
    });
  }
  
  
  fetchAllProducts() {
    this.marketPageService.getAllProducts().subscribe((response) => {
      this.allProductsShow = response.body!.products.map(product => {
        product.averageRating = this.calculateAverageRating(product.reviews);
        // Determine the default image based on product type
        let defaultImageUrl;
        switch (product.type) {
          case 'zelenjava':
            defaultImageUrl = this.vegetableImageUrl;
            break;
          case 'mlečni izdelek':
            defaultImageUrl = this.dairyImageUrl;
            break;
          case 'meso':
            defaultImageUrl = this.meatImageUrl;
            break;
          default:
            defaultImageUrl = this.otherImageUrl;
            break;
        }

        // Assign image URL
        if (!product.image) {
          product.image = defaultImageUrl;
        } else {
          product.image = `${imageLocation}/static/content/${product.productID}/${product.image}`;
        }
        return product;
      });

      this.prodCount = response.body!.count;
      this.allProducts = this.allProductsShow;
      console.log('All Products:', this.allProducts);
    });
  }
  
  calculateAverageRating(reviews?: Review[]): number {
    if (reviews && reviews.length > 0) {
      const total = reviews.reduce((sum, review) => sum + review.rating, 0);
      return total / reviews.length;
    }
    return 0;
  }
  fetchAllFarms() {
    this.marketPageService.getAllFarms().subscribe((response) => {
      this.allFarms = response.body!.farms;
      this.farmCount = response.body!.count;
    });
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

}
